import React, { useMemo } from "react";
import moment from "moment";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";

import { useSchedule } from "../../../../hooks/ScheduleContext";

import {
  Card,
  CurrentDate,
  Day,
  StepButton,
  TodayButton,
  TopRow,
  Week,
} from "./styles";

const FORMATO = "YYYY-MM-DD";

/**
 * Cabecalho de data da agenda.
 *
 * No lugar da regua de anos, meses e de uma tira longa de dias, mostra so a
 * semana do dia escolhido: e o que a loja usa no dia a dia. As setas andam um
 * dia por vez e passam de semana sozinhas; "Hoje" volta para o dia corrente.
 */
export function WeekStrip() {
  const { updateConfig, getConfig } = useSchedule();
  const config = getConfig();

  const selecionado = moment(config.date, FORMATO);
  const hoje = moment().format(FORMATO);

  // duas semanas a partir do domingo da semana escolhida; quantos aparecem
  // depende da largura da tela (ver Week em styles.js)
  const dias = useMemo(() => {
    const inicio = selecionado.clone().startOf("week");
    return Array.from({ length: 14 }, (_, i) => inicio.clone().add(i, "day"));
    // eslint-disable-next-line
  }, [config.date]);

  const vaiPara = (data) => {
    const nova = data.format(FORMATO);
    if (nova === config.date) return;
    updateConfig({ date: nova });
  };

  return (
    <Card>
      <TopRow>
        <TodayButton type="button" onClick={() => vaiPara(moment())}>
          Hoje
        </TodayButton>

        <StepButton
          type="button"
          title="Dia anterior"
          aria-label="Dia anterior"
          onClick={() => vaiPara(selecionado.clone().subtract(1, "day"))}
        >
          <ChevronLeft size={20} />
        </StepButton>

        <StepButton
          type="button"
          title="Próximo dia"
          aria-label="Próximo dia"
          onClick={() => vaiPara(selecionado.clone().add(1, "day"))}
        >
          <ChevronRight size={20} />
        </StepButton>

        <CurrentDate>
          <CalendarDays size={20} aria-hidden="true" />
          {selecionado.format("dddd, D [de] MMMM [de] YYYY")}
        </CurrentDate>
      </TopRow>

      <Week role="group" aria-label="Dias">
        {dias.map((dia) => {
          const valor = dia.format(FORMATO);

          return (
            <Day
              key={valor}
              type="button"
              $selected={valor === config.date}
              $today={valor === hoje}
              aria-pressed={valor === config.date}
              onClick={() => vaiPara(dia)}
            >
              <strong>{dia.format("dddd").replace("-feira", "")}</strong>
              <span>{dia.format("D")}</span>
            </Day>
          );
        })}
      </Week>
    </Card>
  );
}
